module.exports = __webpack_public_path__ + "img/rf4.21407c96.png";